"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Country = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var form = (0, react_final_form_1.useForm)();
    var countries = (0, swr_hooks_1.useCountriesOptions)();
    var currencies = (0, swr_hooks_1.useGenerateCurrencies)();
    var countriesData = (0, swr_hooks_1.useCountries)().data;
    var changeCountryHandler = (0, react_1.useCallback)(function (event) {
        var countryCurrency = countriesData === null || countriesData === void 0 ? void 0 : countriesData.find(function (country) { return country.code === event.value; });
        var currencyToSelect = currencies.find(function (currency) { return currency.value === (countryCurrency === null || countryCurrency === void 0 ? void 0 : countryCurrency.currencyCode); });
        if (currencyToSelect)
            form.change('currency', currencyToSelect);
    }, [currencies, countriesData, form]);
    return (react_1.default.createElement(react_final_form_1.Field, { name: "country", render: function (_a) {
            var _b;
            var input = _a.input, meta = _a.meta;
            return (react_1.default.createElement("div", null,
                react_1.default.createElement(ui_components_1.InputSelect, __assign({}, input, { mode: "light", options: countries, placeholder: t('selectCountry'), hasError: meta.error && meta.touched, onChange: function (event) {
                        input.onChange(event);
                        changeCountryHandler(event);
                    } })),
                meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
        } }));
};
exports.default = Country;
